/* 🤖 this file was generated by svg-to-ts */
export const iconPrice: {
  name: 'price';
  data: string;
} = {
  name: 'price',
  data: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.47461 0.57664L13.8379 1.28367C14.3028 1.33466 14.6696 1.70159 14.7217 2.16648L15.4287 8.53074C15.4617 8.83273 15.3556 9.13411 15.1416 9.3491L8.77832 15.7114C8.59139 15.8993 8.33718 16.0043 8.07129 16.0044C7.80629 16.0044 7.55226 15.8994 7.36426 15.7114L0.292969 8.64109C0.105061 8.45418 0.000102727 8.19892 0 7.93406C0 7.66915 0.105091 7.41401 0.292969 7.22703L6.65723 0.862773C6.87213 0.647907 7.17177 0.540781 7.47461 0.57664ZM2.41406 7.93406L8.07129 13.5903L13.3877 8.27391L12.8223 3.18309L7.73145 2.61668L2.41406 7.93406Z" fill="#444444"/></svg>`,
};
